import { useEffect, useState } from "react";

const MOBILE_WIDTH_THRESHOLD = 430;

export function usePageView() {
  const [isMobileView, setIsMobileView] = useState(
    window.innerWidth <= MOBILE_WIDTH_THRESHOLD
  );

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobileView(window.innerWidth <= MOBILE_WIDTH_THRESHOLD);
    };

    window.addEventListener("resize", updateIsMobile);
    updateIsMobile();

    return () => {
      window.removeEventListener("resize", updateIsMobile);
    };
  }, []);

  return { isMobileView };
}
